/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "./actionTypes";
import { Auth } from "aws-amplify";
import jwtDecode from "jwt-decode";

// check sign in status
export const checkAuthentication = () => {
  return (dispatch) => {
    Auth.currentSession()
      .then((data) => {
        // if signed in set auth data in redux store
        let info = {
          isSignedIn: true,
          accountId: data.idToken.payload["custom:subscriberId"],
          idToken: data.idToken.jwtToken,
          profileName: data.idToken.payload["custom:userProfile"],
        };

        dispatch(setAuthData(info));
      })
      .catch((err) => {
        // if not signed in redirect to login web app
        window.open(process.env.REACT_APP_AUTH_URL, "_self");
      });
  };
};

const setAuthData = (info) => {
  return {
    type: actionTypes.SET_AUTH_DATA,
    auth: info,
  };
};

// method to update unexpired idToken in store and return via promise
export const setToken = () => {
  return (dispatch, getState) => {
    const promise = new Promise((resolve, reject) => {
      let stateToken = getState().auth.idToken;
      try {
        let decoded = jwtDecode(stateToken);
        if (decoded.exp * 1000 >= Date.now()) {
          resolve(stateToken);
        } else {
          Auth.currentSession({ bypassCache: true })
            .then((user) => {
              let token = user.idToken.jwtToken;
              dispatch(authSetToken(token));
              resolve(token);
            })
            .catch((err) => {
              resolve(stateToken);
            });
        }
      } catch (err) {
        Auth.currentSession({ bypassCache: true })
          .then((user) => {
            let token = user.idToken.jwtToken;
            dispatch(authSetToken(token));
            resolve(token);
          })
          .catch((err) => {
            resolve(stateToken);
          });
      }
    });
    return promise;
  };
};

// set auth token in redux store
export const authSetToken = (idToken) => {
  return {
    type: actionTypes.AUTH_SET_TOKEN,
    idToken,
  };
};
